import { PaymentMethod } from '../../../../../store/workspace/types';
import { useDispatch } from '../../../../../store/store';
import styles from './style.module.scss';
import {
    setEditCardModal,
    setDeleteCardModal,
    setSelectedPaymentMethod,
} from '../../../../../store/workspace/slice';

interface Props {
    paymentMethod: PaymentMethod;
};

export default function Card(props: Props) {
    const { paymentMethod } = props;
    const dispatch = useDispatch();

    const deletePaymentMethod = () => {
        dispatch(setSelectedPaymentMethod(paymentMethod));
        dispatch(setDeleteCardModal(true));
    };

    return (
        <div className={styles.wrapper}>
            <span className={styles.title}>{paymentMethod.card.brand}</span>
            <span className={styles.detail}>Credit card ending in **** {paymentMethod?.card?.last4}</span>
            <div className={styles.actions}>
                <span
                    className={styles.actions_edit}
                    onClick={() => dispatch(setEditCardModal(true))}
                >
                    Edit
                </span>
                <span className={styles.actions_devider} />
                <span
                    className={styles.actions_delete}
                    onClick={deletePaymentMethod}
                >
                    Delete
                </span>
            </div>
        </div>
    )
};
